"use client";

import { ChevronRightIcon, ChevronUpIcon } from "lucide-react";
import { trans } from "@/service/i18n/i18n";
import {
  Drawer,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
} from "@/components/ui/drawer";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import { getAtcDepth, getBadgeColor } from "../atc-helpers";

interface AtcMobileDrawerProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  selectedAtc: AtcItem | null;
  children: React.ReactNode;
}

export const AtcMobileDrawer = ({
  open,
  onOpenChange,
  selectedAtc,
  children,
}: AtcMobileDrawerProps) => {
  return (
    <Drawer open={open} onOpenChange={onOpenChange} direction="bottom">
      <DrawerTrigger asChild>
        <button className="flex h-10 w-full cursor-pointer items-center justify-between rounded-lg border border-zinc-300 bg-zinc-50 px-4 py-3 text-left active:bg-gray-50">
          <div className="min-w-0 flex-1">
            {selectedAtc ? (
              <div className="flex items-center gap-2">
                <span className="text-remedium-blue font-semibold">
                  {selectedAtc.code}
                </span>
                <span className="line-clamp-1 text-sm text-gray-600">
                  {selectedAtc.titleText}
                </span>
              </div>
            ) : (
              <span className="text-remedium-blue font-semibold">
                {trans("meds.atc.select_group")}
              </span>
            )}
          </div>
          <ChevronUpIcon size={20} className="ml-2 shrink-0 text-gray-400" />
        </button>
      </DrawerTrigger>
      <DrawerContent className="flex h-[85vh] flex-col">
        <DrawerHeader className="sr-only">
          <DrawerTitle>{trans("meds.atc.navigation")}</DrawerTitle>
        </DrawerHeader>
        <div className="min-h-0 flex-1 overflow-y-auto px-4 pb-24">
          {children}
        </div>
        {selectedAtc && (
          <button
            className="sticky bottom-0 flex h-16 cursor-pointer items-center justify-center gap-1 border-t bg-zinc-100 px-4 py-3 font-semibold"
            onClick={() => onOpenChange(false)}
          >
            <Badge
              className={cn(
                "mr-2",
                getBadgeColor(getAtcDepth(selectedAtc.code)),
              )}
            >
              {selectedAtc.code}
            </Badge>{" "}
            {trans("meds.atc.view_medicines")}{" "}
            <ChevronRightIcon className="size-4 text-slate-500" />
          </button>
        )}
      </DrawerContent>
    </Drawer>
  );
};
